module.exports = __webpack_public_path__ + "img/mining-2.42994930.png";